<template>
  <div class="animated fadeIn">
    <div v-if="template && (!customColorsCarousel ||  template.isClientVersion || template.noColorVersion)">
      <div v-if="template.directDownload && template.videoPreview">
        <video style="max-height: 420px;" controls>
          <source :src="template.videoPreview" type="video/mp4">
        </video>
        <br/>
      </div>
      <div v-else>
        <img :src="template.watermarkedNeutral" :style="{'max-width': (this.isMobileScreen ? '320px' : '200px')}"/>
        <br/>
      </div>
      <br/>
      <b-row class="text-center" v-if="!changingColor && ((me && me.subscription && !me.subscription.isExpired) || isMine)">
        <b-col xs="2" offset-xs="3">
          <b-button @click="expressEdition(template._id)" class="bg-white" variant="outline-primary" v-if="!template.isClientVersion && !template.directDownload"><i class="fa fa-pencil"></i></b-button>
          <button
            class="btn btn-outline-danger bg-white m-t"
            @click="ignoreTemplate(template._id)"
            v-else-if="!template.directDownload"
          >
            <i class="fa fa-undo"></i>
          </button>
        </b-col>
        <b-col xs="2">
          <b-button @click="goToAdminEdition()" class="bg-white" variant="outline-primary" v-if="isAdmin"><i class="fa fa-eye"></i></b-button>
        </b-col>
        <b-col xs="2">
          <button
            v-bind:href="template.fullImage"
            v-if="!downloading"
            @click.prevent="downloadItem(template.directDownload ? template.directDownload : template.fullImage)"
            class="btn btn-outline-default bg-white m-t"
            download
          >
            <i class="fa fa-download"></i>
          </button>
          <Spinner v-if="downloading"/>
        </b-col>
      </b-row> 
      <b-row class="text-center" v-else-if="!changingColor">
        <b-col cols="12">
          Assine o SLEEKER para continuar usando
        </b-col>
      </b-row> 
      <br/>
      <br/>
    </div>
    <div v-else-if="!reloading && template" style="max-width:100%;">
      <div class="content-wrapper m-t">
        <div class="list-wraper">
          <spinner id="loadingDiv" class="m-t" v-if="loaded == false"></spinner>
          <b-row v-show="!changingTextColor && !changingTextFont" style="margin-bottom: 20px;" class="text-center">
            <b-col class="text-center" id="fabric-col">
              <div v-bind:style="{'width': this.heightAndWidth.width + 'px'}" style="height: auto; margin: 0 auto; position: relative;" v-if="(this.template || this.template._id == 'new') && (this.heightAndWidth && this.heightAndWidth.height && this.heightAndWidth.width)">
                <vue-fabric
                  v-show="!choosingElement"
                  crossorigin="Anonymous"
                  ref="canvas1"
                  :canvasId="'canvas' + template._id"
                  :width="this.heightAndWidth.width"
                  :height="this.heightAndWidth.height"
                  :background="template._id == 'new' || template._id == 'new-story'? '#ffffff' : 'transparent'"
                  :backgroundImage="backgroundImage"
                  :allowTouchScrolling="true"
                  v-on:loadedBackground="loaded = true"
                  v-on:afterrender="finishedLoadingCanvas"
                  @selection:created="selected"
                  @selection:updated="selected"
                  @selection:cleared="clearedSelection"
                  @attachment:added="attachmentLoaded"
                  @object:moving="moving"
                  @object:modified="modified"
                ></vue-fabric>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-center" v-if="!changingColor" style="margin-bottom: 10px;">
            <b-col xs="2" offset-xs="3">
              <b-button @click="expressEdition(template._id)" class="bg-white" variant="outline-primary" v-if="!template.isClientVersion && !template.directDownload"><i class="fa fa-pencil"></i></b-button>
            </b-col>
            <b-col xs="2">
              <button
                class="btn btn-outline-danger bg-white m-t"
                v-if="template.isClientVersion"
                @click="ignoreTemplate(template._id)"
              >
                <i class="fa fa-undo"></i>
              </button>
            </b-col>
            <b-col xs="2">
              <button
                v-if="!downloading"
                v-bind:href="template.fullImage"
                @click.prevent="saveTemplate()"
                class="btn btn-outline-default bg-white m-t"
                download
              >
                <i class="fa fa-download"></i>
              </button>
              <Spinner v-if="downloading"/>
            </b-col>
          </b-row> 
        </div>
      </div>
    </div>
    <b-row v-if="convertedInstructions" style="margin-top: -10px; margin-bottom: 10px;">
      <b-col>
        <b-button v-b-toggle="'collapse-' + template._id" variant="primary">Ver Instruções do Card</b-button>
        <b-collapse :id="'collapse-' + template._id" class="mt-2">
          <b-card>
            <b-card-body>
              <div>
                <div style="border-style: solid; border-color: #63c2de; padding: 10px;">
                  <span v-html="convertedInstructions"></span>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueImageModel from "./editor/ImageModel.vue";
import Dropzone from "./Dropzone";
import service from "../service";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import Config from "../config";
import { constants } from "fs";
import { setTimeout } from "timers";
import { Chrome } from "vue-color";
import ColorSlider from './ColorSlider.vue';
import axios from "axios";

export default {
  name: "CarouselItem",
  components: {
    VueImageModel,
    dropzone: Dropzone,
    Spinner,
    ColorSlider,
    "chrome-picker": Chrome,
    Spinner
  },
  props: {
    json: undefined,
    creation: undefined,
    customSavingUrl: undefined,
    originalTemplate: {},
    customColorsTemplate: {},
    customColorsCarousel: false,
    filters: undefined,
    changingColor: false,
    isMine: false
  },
  data() {
    return {
      template: undefined,
      showRemoveUploadModal: false,
      uploadToRemove: undefined,
      userAddedUniques: "",
      psd: false,
      imgUrl: "",
      list: [],
      isMobileScreen: isMobile,
      loading: false,
      jsonCopy: undefined,
      jsonObject: undefined,
      test1: true,
      test2: false,
      advancedEdition: false,
      backgroundImage: "",
      loaded: false,
      loadingAttachment: false,
      actionList: undefined,
      showImportImage: false,
      enableSendToBackground: false,
      currentItem: null,
      showSave: false,
      showTextEdit: false,
      showTrash: false,
      selectedIndex: -1,
      loadingJson: false,
      temporaryText: "",
      selectedColor: "#ffffff",
      changingTextColor: false,
      changingTextFont: false,
      background: "transparent",
      fontList: [
        
      ],
      updatingTextProperties: false,
      story: false,
      preventLocking: false,
      reloading: false,
      forceStory: false,
      disableSaveButton: false,
      lastJson: [],
      baseImageLoaded: false,
      preventUndo: false,
      lineSize: 0.8,
      blockNewSleeker: false,
      choosingElement: false,
      choosingElementVersion: false,
      elements: [],
      selectedElement: undefined,
      customEditorSize: "",
      heightAndWidth: {},
      imgList: [],
      colors: [],
      me: {},
      lastColor: undefined,
      favoriteColors: [],
      shouldListenToFinishedCanva: false,
      downloading: false
    };
  },
  computed: {
    convertedInstructions: function() {
      if (this.originalTemplate && this.originalTemplate.cardInstructions) {
        let instructions = this.originalTemplate.cardInstructions.replace(new RegExp("\n", 'g'), "<br/>");
        
        return instructions;
      }
      return false;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    initialMultiplier: function() {
      let baseWidth = (this.psd) ? (this.json.objects[0].width) : 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalMultiplier: function() {
      let baseWidth = 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalImageMultiplier: function() {
      let baseWidth = this.story ? 1080 : 1200;

      if (this.template && this.template.customEditorWidth) {
        baseWidth = this.template.customEditorWidth;
      }
      
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return false;
      }
      return true;
    }
  },
  created() {
    service.getMe().then(
      response => {
        this.me = response;
      },
      () => {
        this.showError = true;
      }
    );
  },
  mounted() {
    if (this.customColorsCarousel) {
      if (this.customColorsTemplate) {
        this.template = this.customColorsTemplate;
      } else {
        this.template = this.originalTemplate;
        this.template.noColorVersion = true;
      }

      if (this.template.story) {
        this.story = true;
      }

      if (!this.template.isClientVersion) {
        this.calculateHeightAndWidth();
        this.reload();
      }
    } else {
      this.template = this.originalTemplate;

      if (this.template.story) {
        this.story = true;
      }
    }
  },
  methods: {
    finishedLoadingCanvas() {
      if (this.shouldListenToFinishedCanva) {
        if (this.filters) {
          let layer = 1;

          if (this.template.layer) {
            layer = this.template.layer - 1;
          }

          let vm = this;
          vm.$refs["canvas1"].applyFilterToImage(layer, vm.filters);

          this.$emit("finishedLoading");
        }
      }
    },
    goToAdminEdition() {
      this.$router.push({ name: 'Preview Design', params: { id: this.template._id }});
    },
    externalDownload() {
      if (!this.customColorsCarousel || this.template.isClientVersion) {
        this.downloadItem(this.template.directDownload ? this.template.directDownload : this.template.fullImage, true);
      } else {
        this.saveTemplate(true);
      }
    },
    ignoreTemplate(temporaryTemplateId) {
      service.carouselIgnoreTemplate(temporaryTemplateId).then(() => {
        this.$emit("updateCarousel");
      })
    },
    downloadItem(url, dontUseCredit) {
      this.downloading = true;
      this.downloadingFile = true;
      let isVideo = false;
      let extension = url.split("?")[0].split(".")[url.split(".").length - 1];
      axios
        .get(url + "?sada=sadaasdas", { responseType: "blob" })
        .then(({ data }) => {
          let type = "image/png";

          if (extension.indexOf("mp4") >= 0) {
            type = "video/mp4";
            isVideo = true;
          }
          
          if (isVideo) {
            //if (response.status == "ok") {
              const blob = new Blob([data], { type: type });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = localStorage.whitelabelName + Math.floor(Math.random() * 10000) + "." + extension;
              link.click();
              this.downloadingFile = false;
            //}
          } else {
            const blob = new Blob([data], { type: type });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = localStorage.whitelabelName + Math.floor(Math.random() * 10000) + "." + extension;
            link.click();
            this.downloadingFile = false;
          }

          if (!dontUseCredit && !this.isMine) {
            service.useCredits(this.getCreditUseId()).then(
              response => {
                  var event = new CustomEvent("update-me", {});
                  document.dispatchEvent(event);
            }).catch(error => console.error(error));
          }

          this.downloading = false;
          this.$emit("finishedDownload");
           
        })
        .catch(
          error => {
            if (error && error.message && error.message.indexOf("403") >= 0) {
              let vm = this;
              setTimeout(function() {
                vm.downloadItem(url, dontUseCredit);
              }, 1000);
            } else {
              console.error(error)
            }
          }
        );
    },
    getCreditUseId() {
      if (this.template.isClientVersion) {
        return this.template.originalTemplateId;
      } else {
        return this.template._id;
      }
    },
    goToEditor() {
      if (this.$route.query.firstEdition) {
        //?firstEdition1
      }
    },
    expressEdition: function() {
        this.$emit("expressEdition", {id: this.template._id});
    },
    changeColor(filters) {
      this.lastHue = filters.hueValue;
      this.lastSaturation = filters.saturationValue;
      this.lastBrightness = filters.brightnessValue;
      this.filters = filters;
      let layer = 1;

      if (this.template.layer) {
        layer = this.template.layer - 1;
      }

      if (filters.id) {
        this.lastColor = filters.id;
      }
        
      this.$refs["canvas1"].applyFilterToImage(layer, filters);
    },
    saveColor() {
      service.saveColor({hue: this.lastHue, saturation: this.lastSaturation, brightness: this.lastBrightness}).then(() => {
        this.getColors();
      });
    },
    getColors() {
      service.getColors().then((result) => {
        

        if (result.favoriteColors && result.favoriteColors.length) {
          this.favoriteColors = [];

          for (let key in result.colors) {
            if (result.favoriteColors.indexOf(result.colors[key]._id) >= 0) {
              this.favoriteColors.push(result.colors[key]);
            }
          }
        }

        this.colors = result.colors;
      });
    },
    saveTemplate(dontUseCredit) {
      this.downloading = true;
      if (this.dontAskAgain) {
        localStorage.dontAskAgain = true;
      }
      
      this.disableSaveButton = true;
      let json = this.$refs["canvas1"].toJson();

      let vm = this;

      for (let i = 0; i < json.objects.length; i++) {
        json.objects[i].scaleX *= vm.finalMultiplier;
        json.objects[i].scaleY *= vm.finalMultiplier;
        json.objects[i].left *= vm.finalMultiplier;
        json.objects[i].top *= vm.finalMultiplier;
      }

      if (!this.me || !this.me.newSaveEnabled) {
        this.$refs["canvas1"].toBlob({
          format: "png",
          multiplier: this.finalImageMultiplier
        }, function(previewData) {
          var reader = new FileReader();

          reader.onloadend = function() {
            var base64data = reader.result; 
            vm.tryUpload(0, json, base64data).then((result) => {
              if(result && result.temporaryId) {
                service.getTemporaryDesign(result.temporaryId).then(
                  response => {
                    
                    setTimeout(function() {
                      vm.downloadItem(response.temporaryDesign.fullImage, dontUseCredit);
                    }, 3000);
                });
              }    
            }).catch(() => {
              vm.disableSaveButton = false;
            });  
          }
          reader.readAsDataURL(previewData); 
        });
      } else {
        vm.tryUpload(0, json, undefined).then((result) => {
          if(result && result.temporaryId) {
            service.getTemporaryDesign(result.temporaryId).then(
              response => {
                
                setTimeout(function() {
                  vm.downloadItem(response.temporaryDesign.fullImage, dontUseCredit);
                }, 3000);
            });
          }    
        }).catch(() => {
          vm.disableSaveButton = false;
        });  
      }
    },
    tryUpload(attempt, json, previewData) {
      return new Promise((resolve, reject) => {
        try {
          let textValue = JSON.stringify({ json: json, story: (this.isStory || (this.template && this.template.story)), originalTemplateId: this.templateId, creationId: this.creation, customColors: this.customColors, newTemplate: previewData });
          service
            .saveExpressTemplateFromText(textValue)
            .then(result => {
              if(result && result.temporaryId) {
                  if (attempt > 0) {
                    //service.reportError("Funcionou na tentativa " + (attempt + 1) + "<br/> Link para o save-design: https://sleeker.pt/design/save/" + result.temporaryId);
                  }
                  this.disableSaveButton = false;
                  resolve(result);
              } else {
                alert("Erro 9.2. Tente finalizar novamente. Se não funcionar, procure o Suporte.");
                this.disableSaveButton = false;
                reject();
              }          
            }).catch((error) => {
              try {
                if (attempt < 6) {
                  return this.tryUpload(attempt + 1, json, previewData);
                } else {
                  alert("Erro 9.3. Tente finalizar novamente. Se não funcionar, procure o Suporte.");
                  service.reportError("Tentou 8 vezes e falhou");
                  if (textValue) {
                    service.reportError("length: " + textValue.length);
                    service.reportError("substring: " + textValue.slice(0, 100000));
                    service.reportError("value: " + textValue);
                  } else {
                    service.reportError("sem text value");
                  }

                  if (error) {
                    service.reportError(JSON.stringify(error));
                  }
                  
                  service.reportError("Tentou 8 vezes e falhou - email 2");
                  this.disableSaveButton = false;
                  reject();
                }
              } catch {
                alert("Erro 9.1. Tente finalizar novamente. Se não funcionar, procure o Suporte.");
                this.disableSaveButton = false;
                reject();
              }
            });
        } catch (error) {
          alert(error);
          alert("Erro 9.4. Tente finalizar novamente. Se não funcionar, procure o Suporte.");
          this.disableSaveButton = false;
          reject();
        }
      });
    },
    sendToBackground() {
      this.$refs["canvas1"].toBottomLayer();
      this.$refs["canvas1"].toLastLayer();
    },
    handleCompleteLoad() {
      if (this.baseImageLoaded == false) {

      } else {
        
      }
    },
    reload(force) {
      this.calculateHeightAndWidth();

      this.reloading = false;
      this.loaded = false;

      if (force == true) {
        this.loaded = true;
      }
    
      this.advancedEdition = true;
      this.jsonObject = this.template.json.objects;
      this.backgroundColor = this.template.json.background;
      this.jsonCopy = this.calculateScale();
      this.loaded = true;

      this.loadJSON(this.jsonCopy, null, this.handleCompleteLoad);
    },
    calculateHeightAndWidth() {
      let baseHeight = (this.isMobileScreen) ? 320 : 200;
      let baseWidth = (this.isMobileScreen) ? 320 : 200;

      if (this.story) {
        baseHeight = (this.isMobileScreen) ? 355 : 355;
        baseWidth = (this.isMobileScreen) ? 200 : 200;
      }

      if (this.template && this.template.customEditorHeight && this.template.customEditorWidth) {
        let heightFactor = this.template.customEditorHeight / baseHeight;
        let widthFactor = this.template.customEditorWidth / baseWidth;
        let finalFactor = (widthFactor > heightFactor) ? widthFactor : heightFactor;
        let height = this.template.customEditorHeight / finalFactor;
        let width = this.template.customEditorWidth / finalFactor;
        
        this.heightAndWidth = { height: height, width: width };
      } else {
        this.heightAndWidth = { height: baseHeight, width: baseWidth };
      }
    },
    unlockAll() {
      this.preventLocking = true;
      if (this.actionList) {
        this.loadJSON(this.actionList, true, () => {});
      }
    },
    saveText() {
      this.currentItem.text = this.temporaryText;

      this.loadJSON(this.$refs["canvas1"].toJson());
    },
    loadUploads() {
      service.getUploads().then(
        response => {
          if (response && response.result) {
            this.list = response.result;
          }
        },
        () => {
          this.showError = true;
        }
      );
    },
    decodeString(str) {
      return  str.replace(/\\xe3/g,"ã").replace(/\\r/g,"\n").replace(/\\xc7/g,"Ç").replace(/\\xc1/g,"Á").replace(/\\xe1/g,"á").replace(/\\xc3/g,"Ã").replace(/\\xea/g,"ê").replace(/\\xca/g,"Ê").replace(/\\xed/g,"í").replace(/\\xcd/g,"Í").replace(/\\xf5/g,"õ").replace(/\\xd5/g,"Õ").replace(/\\xe9/g,"é").replace(/\\xc9/g,"É").replace(/\\xf3/g,"ó").replace(/\\xd3/g,"Ó").replace(/\\xfa/g,"ú").replace(/\\xda/g,"Ú").replace(/\\xe7/g,"ç");      
    },
    loadJSON(json, preventEditOptionsClosing, cb, decodeStrings) {
      if (!this.$refs["canvas1"]) {
        setTimeout(() => {
          this.loadJSON(json, preventEditOptionsClosing, cb);
        }, 1000);
        return;
      }

      this.actionList = [];
      var index = 0;
      this.loadingJson = true;
      let jsonBack = undefined;
      let biggest = 0;

      this.actionList = json;
      for (let i = 0; i < this.actionList.objects.length; i++) {
        let templateItem = this.actionList.objects[i];

        this.actionList.objects[i].hasControls = false;
        this.actionList.objects[i].lockRotation = true;
        this.actionList.objects[i].lockMovementX = true;
        this.actionList.objects[i].lockMovementY = true;
        this.actionList.objects[i].evented = false;

        if (
          (this.actionList.objects[i] &&
            (this.actionList.objects[i].type &&
              this.actionList.objects[i].type == "i-text")) ||
          this.actionList.objects[i].text
        ) {
          this.actionList.objects[i].id = index;
          if (decodeStrings) {
            this.actionList.objects[i].text = this.decodeString(this.actionList.objects[i].text);
          }
          index++;
          if (this.isMobileScreen) {
            this.actionList.objects[i].editable = false;
          }
        } else if (
          this.actionList.objects[i] &&
          this.actionList.objects[i].type &&
          this.actionList.objects[i].type == "image"
        ) {
          this.imgList.push(this.actionList.objects[i]);
          this.actionList.objects[i].crossOrigin = "anonymous";
          this.actionList.objects[i].filters = [new       fabric.Image.filters.HueRotation()];
        }
        if (
          this.actionList.objects[i].scaleX * this.actionList.objects[i].width >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleX *
            this.actionList.objects[i].width;
          jsonBack = this.actionList.objects[i];
        }
        if (
          this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height >
          biggest
        ) {
          biggest =
            this.actionList.objects[i].scaleY *
            this.actionList.objects[i].height;
          jsonBack = this.actionList.objects[i];
        }
      }

      if (jsonBack && !this.actionList.backgroundImage) {
        /*
        if (this.preventLocking) {
          jsonBack.hasControls = true;
          jsonBack.lockRotation = false;
          jsonBack.lockMovementX = false;
          jsonBack.lockMovementY = false;
        } else {
          jsonBack.hasControls = false;
          jsonBack.lockRotation = true;
          jsonBack.lockMovementX = true;
          jsonBack.lockMovementY = true;
        }
        */
      } else if (this.actionList.backgroundImage) {
        this.actionList.backgroundImage.crossOrigin = "anonymous";
      }

      if (json && json.objects && json.objects.length > 0) {
        this.shouldListenToFinishedCanva = true;
        this.$refs["canvas1"].loadFromJSON(json, () => {
          this.loaded = true;
          this.currentItem = undefined;
          this.loadingJson = false;
          this.preventUndo = false;

          if (!preventEditOptionsClosing) {
            this.showImportImage = false;
            this.enableSendToBackground = false;
            this.showSave = false;
            this.showTextEdit = false;
          }

          let layer = 1;

          if (this.template.layer) {
            layer = this.template.layer - 1;
          }

          if (cb) {
            cb();
          }
        });
      } else {
        if (cb) {
          cb();
        }
        this.loadingJson = false;
      }
    },
    calculateScale() {
      var jsonCopyItem = { objects: [] };

      var jsonObjectsCopy = JSON.parse(JSON.stringify(this.jsonObject));

      for (var i = 0; i < jsonObjectsCopy.length; i++) {
        jsonObjectsCopy[i].scaleX = jsonObjectsCopy[i].scaleX / this.initialMultiplier;
        jsonObjectsCopy[i].scaleY = jsonObjectsCopy[i].scaleY / this.initialMultiplier;
        jsonObjectsCopy[i].left = jsonObjectsCopy[i].left / this.initialMultiplier;
        jsonObjectsCopy[i].top = jsonObjectsCopy[i].top / this.initialMultiplier;

        jsonCopyItem.objects.push(jsonObjectsCopy[i]);
      }

      if (this.backgroundColor) {
        jsonCopyItem.background = this.backgroundColor;
      }

      return jsonCopyItem;
    }
  }
};
</script>
